import { useChipsContext } from '../../chips'
import { ChipsLabelVariants } from '../../chips.styles'
import type { ChipsLabelProps, ChipsScopedProps } from '../../chips.types'

export const ChipsLabel = (props: ChipsScopedProps<ChipsLabelProps>) => {
  const { __scopeChips, children } = props
  const { size, disabled, checked } = useChipsContext('Label', __scopeChips)

  return (
    <span className={ChipsLabelVariants({ disabled, size, checked })}>
      {children}
    </span>
  )
}
